import type { ReactNode } from 'react';
import { Inbox, type LucideIcon } from 'lucide-react';
import { StateMessage } from '@/components/common/StateMessage';
import { TableCell, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import { TABLE_VISIBLE_WIDTH_CLASS } from './dataTable.constants';

interface DataTableEmptyProps {
  columnCount: number;
  icon?: LucideIcon | undefined;
  message?: string | undefined;
  hint?: string | undefined;
  actions?: ReactNode;
}

export function DataTableEmpty({
  columnCount,
  icon = Inbox,
  message = 'No results found',
  hint = 'Try adjusting filters or search to see more.',
  actions,
}: DataTableEmptyProps) {
  return (
    <TableRow className="hover:bg-transparent border-b-0 h-full">
      <TableCell colSpan={columnCount} className="h-48 px-0 text-center align-middle">
        <div
          className={cn(
            'sticky left-0 flex justify-center px-2 whitespace-normal',
            TABLE_VISIBLE_WIDTH_CLASS,
          )}
        >
          <StateMessage
            icon={icon}
            tone="neutral"
            title={message}
            description={hint}
            size="compact"
            actions={actions}
          />
        </div>
      </TableCell>
    </TableRow>
  );
}
